var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',_vm._g(_vm._b({staticClass:"store-cate-type-tabs-component"},'el-tabs',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.list),function(ref){
var label = ref.label;
var id = ref.id;
var slotName = ref.slotName;
return _c('el-tab-pane',{key:id,attrs:{"label":label,"name":id}},[(_vm.isShowTab(id))?_vm._t(slotName):_vm._e()],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }